"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLink = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var emotion_1 = require("emotion");
var styles = (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  text-decoration: none;\n  word-break: break-word;\n"], ["\n  text-decoration: none;\n  word-break: break-word;\n"])));
var AppLink = function (props) {
    var _a = props.className, className = _a === void 0 ? '' : _a, to = props.to, title = props.title, children = props.children, disabled = props.disabled;
    if (disabled) {
        return react_1.default.createElement("span", { className: "AppLink ".concat(styles, " ").concat(className) }, children);
    }
    if (to) {
        return (react_1.default.createElement(react_router_dom_1.Link, tslib_1.__assign({ title: title }, props, { to: to, className: "AppLink ".concat(styles, " ").concat(className) }), children));
    }
    return (react_1.default.createElement("a", tslib_1.__assign({}, props, { title: title, className: "AppLink ".concat(styles, " ").concat(className) }), children));
};
exports.AppLink = AppLink;
var templateObject_1;
